import React from 'react';
import _ from 'lodash';
import formConfigMap from '../config/formConfigMap';

const createItem = function createItem(type, properties) {
  let componentProperties = properties;
  if (!properties.name) {
    throw new Error('Name prop required, it is being used as the `key` attribute.');
  }
  let component = formConfigMap.missing;
  if (formConfigMap[type] !== undefined) {
    component = formConfigMap[type];
  } else {
    component = formConfigMap.missing;
    componentProperties = Object.assign({}, properties, {
      label: 'Unknown',
      edit: false,
    });
  }
  try {
    return React.createElement(component, Object.assign({}, componentProperties, {
      key: `key-${properties.name}`,
    }));
  } catch (e) {
    console.error(e);
    return null;
  }
};

const getItem = function getItem(configs, type, title, properties) {
  let form = null;
  let formLabel = null;
  let formConfig;
  let itemType = type;

  if (title === 'service_name') {
    formConfig = _.find(configs, { service_name: type });
  }
  if (title === 'work_order_name') {
    formConfig = _.find(configs, { work_order_name: type });
  }
  if (formConfig) {
    form = _.find(formConfig.form, { name: properties.name });
    if (form) {
      itemType = form.type;
      formLabel = form.label;
    }
  }
  try {
    return createItem(itemType, Object.assign({}, properties, {
      label: formLabel,
      form,
    }));
  } catch (e) {
    console.error(e);
    return null;
  }
};

const getFormItems = function getFormItems(options, properties) {
  const {
    body,
    type,
    configs,
    title,
  } = options;

  let mappedForms = [];
  try {
    if (body && configs) {
      mappedForms = _.map(body, (val, name) => getItem(configs, type, title, Object.assign({}, properties, {
        name,
        val,
      })));
    }
  } catch (e) {
    console.error(e);
  }
  return mappedForms;
};

export default {
  getFormItems,
  getItem,
  createItem,
};



// WEBPACK FOOTER //
// ./src/utils/forms.js